PageApp.Views.AdminFooterView = Backbone.Marionette.ItemView.extend({
  template: hbs.templates.adminFooter,
  initialize: function (options) {
    this.options = options
  },
  serializeData: function () {
    var showPoweredByLink = true
    var webAppName = myApp.ent.webApp.get('name')
    if (webAppName && webAppName.toLowerCase() !== 'bidlogix') {
      showPoweredByLink = false
    }
    var content = {
      contextPath: myApp.ent.config.get('contextPath'),
      JspPublicCodes_JSP_LAST_LOGGED_IN: myApp.reqres.request('i16:getString', 'JspPublicCodes_JSP_LAST_LOGGED_IN'),
      JspPublicCodes_JSP_COPYRIGHT: myApp.reqres.request('i16:getString', 'JspPublicCodes_JSP_COPYRIGHT'),
      poweredByLink: 'https://www.bidlogix.net',
      showPoweredByLink: showPoweredByLink
    }
    return content
  }
})
